<template>
  <div class="app-wrap">
    <Header v-if="$route.name === 'home'"></Header>
    <HeaderColumn v-if="$route.name !== 'home'"></HeaderColumn>
    <Main v-if="$route.name === 'home'"></Main>
    <MainColumn v-if="$route.name !== 'home'"></MainColumn>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './Header'
  import HeaderColumn from './Header-column'
  import Main from './Main'
  import MainColumn from './Main-column'
  import Footer from './Footer'
	export default {
		name: "Index",

    components: {
      Header,
      HeaderColumn,
      Main,
      MainColumn,
      Footer
    },

		methods: {

		},
	}
</script>

<style>

</style>
